import React, {useContext} from "react";
import {GroupContext} from "../GroupContex";
import {ITelegramParams} from "../../../interfaces/ITelegramParams";
import {FormHelperText, TextField} from "@leap4/frontend";

export const TelegramParamsForm = () => {
    const {group, setGroup} = useContext(GroupContext);
    const groupParams = group.params as ITelegramParams;

    const updateGroupParams= (e) =>{
        setGroup({...group, params: {...group.params, [e.target.name]: e.target.value}})
    };

    return <>
        <FormHelperText>
            Chat Id
        </FormHelperText>
        <TextField
            style={{marginBottom:10}}
            fullWidth
            value= {groupParams?.chatId}
            onChange={updateGroupParams}
            size="small"
            variant="outlined"
            name="chatId"
            className={"gridItem"}
        />

        <FormHelperText>
            Bot Token
        </FormHelperText>
        <TextField
            style={{marginBottom:10}}
            fullWidth
            value= {groupParams?.botToken}
            onChange={updateGroupParams}
            size="small"
            variant="outlined"
            name="botToken"
            className={"gridItem"}
        />

    </>
}